export const squareStyle = {
  backgroundSize: 'cover',
  paddingBottom: '100%',
  width: '100%',
  borderRadius: '4px'
}
